__turbopack_context__.v({
  "container": "aboutCompanySection-module-scss-module__WqNDfG__container",
  "content": "aboutCompanySection-module-scss-module__WqNDfG__content",
  "heading": "aboutCompanySection-module-scss-module__WqNDfG__heading",
  "list": "aboutCompanySection-module-scss-module__WqNDfG__list",
  "listContainer": "aboutCompanySection-module-scss-module__WqNDfG__listContainer",
  "pictures": "aboutCompanySection-module-scss-module__WqNDfG__pictures",
  "separator": "aboutCompanySection-module-scss-module__WqNDfG__separator",
  "starIcon": "aboutCompanySection-module-scss-module__WqNDfG__starIcon",
  "video": "aboutCompanySection-module-scss-module__WqNDfG__video",
});
